import ProjectCard from "./ProjectCard";

import messenger from '../../assets/messenger-app2.jpeg'
import api from "../../assets/admin-api.jpeg"
import buscaHerois from "../../assets/hero2.jpeg"

export default function Projects() {
    return (
        <>
            <div id="projects" className="mt-4 py-[70px] text-white">
                <h1 className="text-2xl font-bold">Projects</h1>
                <p className="font-light text-gray-400">Here are some of my projects</p>

                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4  justify-center mt-4 gap-4">
                    {projects.map((project) => (
                        <ProjectCard 
                            name={project.name}
                            siteUrl={project.siteUrl}
                            img={project.image}
                            description={project.description}
                            sourceCode={project.sourceCode}
                            issued="Trybe"
                            date="Oct 2020"
                            status={project.status}
                        />
                    ))}                  
                </div>
                
            </div>
        </>
    )
}


const projects = [
    {
        name: "Real Time Messenger App NextJs",
        image: messenger,
        siteUrl: "https://messenger-app-next-one.vercel.app/",
        sourceCode: "https://github.com/rodolfo-code/messenger-app-next",
        description: "Real-time messaging app, fully responsive, multi-user, with OAuth. Developed using Next js, Tailwind, Prisma, MongoDb and Pusher.",
        status: "Deployed"
    },
    {
        name: "Video Catalog Microservice",
        image: api,
        siteUrl: "",
        sourceCode: "https://github.com/rodolfo-code/admin-catalogo-de-videos-c-sharp",
        description: "Microservice referring to the Video Catalog Administration using C#, .NET, EntityFramework, Clean Architecture, DDD, TDD with xUnit",
        status: "under development"
    },
    {
        name: "Hero search app using NextJs",
        image: buscaHerois,
        siteUrl: "https://busca-de-herois.vercel.app/",
        sourceCode: "https://github.com/rodolfo-code/busca_de_herois/tree/main",
        description: "Hero search app using Marvel API, developed in NextJs and Marvel API.",
        status: "Deployed"
    },
    
]